
export const styles = `
/* Use the DejaVu Sans font for displaying and embedding in the PDF file. The standard PDF fonts do not support Unicode characters. */
  .testDetailsPDF div {
      font-family: "DejaVu Sans", "Arial", sans-serif;
      font-size: 10px;
  }

  /*
    The example loads the DejaVu Sans from the Kendo UI CDN.
    Other fonts have to be hosted from your application.
    The official site of the Deja Vu Fonts project is
    https://dejavu-fonts.github.io/.
  */
  @font-face {
    font-family: "nike-glyphs";
    src: url("https://assets.commerce.nikecloud.com/ncss/glyphs/2.1/fonts/nike-glyphs.ttf") format("truetype");
  }
`;

